export default "__VITE_ASSET__De4lL_A3__"